import {Component, OnDestroy, OnInit} from '@angular/core';
import {ServiceVersions, VersionInfo} from '../../../domain/cloud-topology';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {VersionService} from '../../../services/version.service';
import {forkJoin, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    standalone: false
})
export class AboutComponent implements OnInit, OnDestroy {
  versions: ServiceVersions;
  private subscription$: Subject<void>;
  constructor(public activeModal: NgbActiveModal,
              private versionService: VersionService) { }

  ngOnInit() {
    this.subscription$ = new Subject<void>();

    this.versionService.getServiceInfo().pipe(takeUntil(this.subscription$)).subscribe(data =>  {
      this.versions = data;
    });
  }

  ngOnDestroy(): void {
    this.subscription$.next();
    this.subscription$.complete();
  }

}
